// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wo_a bie_b bie_we"};